<template>
	<svg
		width="14"
		height="15"
		viewBox="0 0 14 15"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		:class="classes"
	>
		<g clip-path="url(#clip0_3777_4618)">
			<path
				d="M11.0832 4.23925L10.2607 3.41675L6.99984 6.67758L3.739 3.41675L2.9165 4.23925L6.17734 7.50008L2.9165 10.7609L3.739 11.5834L6.99984 8.32258L10.2607 11.5834L11.0832 10.7609L7.82234 7.50008L11.0832 4.23925Z"
				fill="#073B5D"
			/>
		</g>
		<defs>
			<clipPath id="clip0_3777_4618">
				<rect
					width="14"
					height="14"
					fill="white"
					transform="translate(0 0.5)"
				/>
			</clipPath>
		</defs>
	</svg>
</template>

<script setup>
const props = defineProps({
	classes: {
		type: String,
		default: ''
	}
});
</script>